export default __webpack_public_path__ + "static/media/recuadroDos.246d8ae2.png";